import { paymentMethodConfigurationQualifiers, QualifierCondition } from './paymentMethodConfigurationConditions';

interface PaymentMethodConfigurationEnricher {
  enrich(configuration: any, paymentMethodId: string): void;
}

export const PaymentMethodConfigurationEnricher: PaymentMethodConfigurationEnricher =
  {
    enrich: (configuration: any, paymentMethodId) => {
      paymentMethodConfigurationQualifiers.forEach((qualifier) => {
        const isQualifierSuitable = qualifier.conditions.some((condition: QualifierCondition) => {
          if (condition.type === 'startWith') {
            return paymentMethodId.startsWith(condition.value);
          } else {
            return paymentMethodId === condition.value;
          }
        });

        if (isQualifierSuitable) {
          configuration[qualifier.result.component][qualifier.result.property] =
            qualifier.result.value;
        }
      });
    },
  };
